import Image from 'next/image';
import {
  Button,
  Container,
  Htag,
  HtagAlign,
  HtagVariant,
} from '../../components';
import styles from './logistic-consultation.module.css';

import victoria from '../../public/logistic/victoria-min.jpg';
import MailIcon from '../../public/logistic/mail.svg';
import MessageIcon from '../../public/logistic/message.svg';
import LinkedinIcon from '../../public/logistic/linkedin.svg';

export default function LogisticConsultation() {
  return (
    <section className={styles.root}>
      <Container>
        <Htag
          variant={HtagVariant.h2}
          align={HtagAlign.center}
          className={styles.title}
          tag="h2"
        >
          Why Hire mavinx as Logistics Software Development Company
        </Htag>
        <div className={styles.card}>
          <div className={styles.card__start}>
            <Image
              alt="Victoria Sheinina photo"
              width={442}
              height={406}
              src={victoria}
            />
            <div className={styles.card__row}>
              <span className={styles.card__name}>Victoria Sheinina</span>
              <div className={styles.card__social}>
                <span className={styles.card__social_item}>
                  <a href="#" rel="noopener noreferrer">
                    <MailIcon />
                  </a>
                </span>
                <span className={styles.card__social_item}>
                  <a href="#" rel="noopener noreferrer">
                    <MessageIcon />
                  </a>
                </span>
                <span className={styles.card__social_item}>
                  <a href="#" rel="noopener noreferrer">
                    <LinkedinIcon />
                  </a>
                </span>
              </div>
            </div>
            <span className={styles.card__position}>Logistics expert</span>
            <Button
              tag="a"
              appearance="primary"
              href="/contact"
              style={{ width: '100%' }}
            >
              get consultation
            </Button>
          </div>

          <div className={styles.card__end}>
            <ul className={styles.card__list}>
              <li className={styles.card__item}>
                <h6 className={styles.card__title}>
                  Optimizing supply chains to minimize costs
                </h6>
                <p className={styles.card__text}>
                  Solutions that consider the latest industry standards
                  regarding security, usability, and interoperability. Meeting
                  standards and regulations: GDPR, Regulation (EC) No 561/2006,
                  Regulation (EEC) No 3821/85, Regulation (EC) No 2135/98,
                  Regulation (EU) No 165/2014.
                </p>
              </li>
              <li className={styles.card__item}>
                <h6 className={styles.card__title}>Full-cycle development</h6>
                <p className={styles.card__text}>
                  End-to-end software development, including Discovery Phase,
                  creating bespoke UI/UX designs and prototypes, Delivery and
                  post-production support.
                </p>
              </li>
              <li className={styles.card__item}>
                <h6 className={styles.card__title}>Technology expertise</h6>
                <p className={styles.card__text}>
                  Cleveroad certified experts help businesses choose the best
                  tech stack for the particular case and advise the
                  architecture, allowing to achieve the business goals of the
                  project.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </Container>
    </section>
  );
}
